export default function explanation() {
    var explanations = document.querySelectorAll(".explanation");
    if(explanations && explanations.length>0) {
        for(var x=0; x < explanations.length; x++) {
            var curExplanation = explanations[x];
            var image = curExplanation.querySelector(".explanation-image");
            if(image) {
                var videoPlayLink = image.querySelector(".video-play-link");
                if(videoPlayLink) {
                    videoPlayLink.onclick = function(e) {
                        e.preventDefault();
                        const targetExplanation = e.target.closest(".explanation");
                        if(targetExplanation) {
                            targetExplanation.classList.add("play");
                            var video = targetExplanation.querySelector("iframe");

                            let dataSrc = video.getAttribute('data-src');
                            if (dataSrc) {
                                setTimeout(() => {
                                    video.setAttribute('src', dataSrc);
                                }, 100);
                            }
                        }
                    }
                }
            }

            var element = curExplanation.querySelector('.explanation-video');
            if(element) {
                element.scrollIntoView(false);
            }
        }
    }
}
